
import Vue from "vue";
import { Component, Model, Prop, Watch } from "vue-property-decorator";
import suneditor from "suneditor";
import { en } from "suneditor/src/lang";
import SunEditor from "suneditor/src/lib/core";
import { link, list, textStyle, paragraphStyle } from "suneditor/src/plugins";
// import plugins from "suneditor/src/plugins"


@Component
export default class TextEditor extends Vue {

    $refs!: {
        vue: Vue,
        element: HTMLInputElement,
        vues: Vue[],
        elements: HTMLInputElement[]
    }

    // XSS attack possible so be careful with your inputs
    @Model("input", { required: true, type: String })
    public readonly htmlContent: string;

    @Prop({ default: false, type: Boolean })
    public readonly disabled: boolean;

    public editor: SunEditor | null = null;

    public sunEditorHtmlContent = "";


    get sunRef(): any {
        return this.$refs["text-editor"];
    }

    @Watch("disabled")
    public onDisabledChange(): void {
        console.log("onDisabledChange", this.disabled);

        if (this.disabled) {
            this.editor?.disable();
            this.editor.toolbar.hide();
        } else {
            this.editor?.enable();
            this.editor.toolbar.show();
        }
    }

    @Watch("htmlContent")
    public onHtmlContentChange(): void {
        if (this.htmlContent && this.htmlContent !== this.sunEditorHtmlContent) {
            this.updateSunEditorHtmlContent();
        } else
            if (!this.htmlContent) {
                this.editor.setContents("");
            }
    }

    public mounted(): void {

        this.editor = suneditor.create(this.sunRef, {
            plugins: [textStyle, list, link, paragraphStyle],
            buttonList: [
                ["bold", "underline", "italic"],
                ["list"],
                ["link"],
            ],
            addTagsWhitelist: "p|a|ul|li|ol|b|i|u",
            tagsBlacklist: "script|style",
            lang: en,
            resizeEnable: false,
            mode: "classic",
            width: "100%",
            height: "100%",
        });

        this.editor.disable();
        this.editor.toolbar.hide();


        if (this.htmlContent) {
            this.updateSunEditorHtmlContent();
        }


        if (!this.disabled) {
            this.editor.enable();
            this.editor.toolbar.show();
        }

        this.editor.onChange = (contents, core) => {
            this.sunEditorHtmlContent = contents;

            this.$emit("input", contents);
        };

    }

    private updateSunEditorHtmlContent() {
        this.sunEditorHtmlContent = this.htmlContent;
        // XSS attack possible so be careful with your inputs
        this.editor.setContents(this.sunEditorHtmlContent);
    }
}
